import { render, staticRenderFns } from "./StampCardsView.vue?vue&type=template&id=1f839e96&"
import script from "./StampCardsView.vue?vue&type=script&lang=js&"
export * from "./StampCardsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports